import * as React from "react";
const SvgFiRrRegistrationPaper = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-registration-paper_svg__a)">
      <path
        fill="#062147"
        d="M21 17h-1v-1a1 1 0 1 0-2 0v1h-5c-1.654 0-3 1.346-3 3v.5c0 .827-.673 1.5-1.5 1.5S7 21.327 7 20.5v-17c0-.539-.133-1.044-.351-1.5H9a1 1 0 1 0 0-2H3.5C1.57 0 0 1.57 0 3.5V4c0 1.654 1.346 3 3 3h2v13.5A3.504 3.504 0 0 0 8.498 24H20.5c1.93 0 3.5-1.57 3.5-3.5V20c0-1.654-1.346-3-3-3M5 5H3c-.552 0-1-.449-1-1v-.5C2 2.673 2.673 2 3.5 2S5 2.673 5 3.5zm17 15.5c0 .827-.673 1.5-1.5 1.5h-8.838c.217-.455.338-.963.338-1.5V20c0-.551.448-1 1-1h8c.552 0 1 .449 1 1zM17 14c3.859 0 7-3.14 7-7s-3.141-7-7-7-7 3.14-7 7 3.141 7 7 7m0-12c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5m-3.482 4.8a1 1 0 0 1 1.414-.015l1.131 1.108a.377.377 0 0 0 .522 0l2.223-2.134a1 1 0 0 1 1.385 1.443L17.98 9.326a2.35 2.35 0 0 1-1.653.671 2.37 2.37 0 0 1-1.664-.674l-1.131-1.108a1 1 0 0 1-.014-1.415"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-registration-paper_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRegistrationPaper;
